// import Footer from "../../components/footer/Footer.tsx";
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
import { useEffect, useState } from "react";
import { getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import {  useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/spinner/Spinner.tsx";


interface Advertise {
      id: string,
      supplierId: string,
      advertiseTypeId: number,
      title: string,
      image: string,
      description: string,
      startDate: string,
      endDate: string,
      price: null,
      status: boolean,
      createdAt: string
      updatedAt: string
}

const AdsDetail1 = () => {
    const [advertise, setAdvertise] = useState<Advertise | null>(null);
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [mainImage, setMainImage] = useState<string>('');

  
    // GET ADVERTISES BY ID
    useEffect(() => {
      const getAdvertisesById = async () => {
        setLoading(true);
          try {
              const response = await getFetcher(endpoints.advertises.getAdvertiseById.replace('{id}', id || ''));
              if (response.result) {
                  setAdvertise(response.advertise);
                  if(response.advertise.image) {
                    setMainImage(response.advertise.image);
                  }else {
                    setMainImage('https://static.thenounproject.com/png/4595376-200.png');
                  }
                  setLoading(false);
              } else {
                  toast.error(response.message || 'Error');
              }
          } catch (error) {
              console.error('Reklam ürünleri getirilirken hata oluştu:', error);
          }
      }

      getAdvertisesById();
  }, [id]);

  if(loading) {
    return <div><Spinner /></div>
  }

  return (
    <main className="flex-grow flex flex-col min-h-screen">
      {/* <Header />
      <Navbar /> */}

      {/* Center image and company title*/}

      <img
        src={mainImage}
        alt="Ad Image"
        className="mx-auto w-full md:w-3/4 max-w-[750px] max-h-[500px] mb-200 my-2 rounded-xl shadow-xl"
      />
      <h1 className="text-center text-4xl font-semibold my-6 text-primary-color">
        {advertise?.title}
      </h1>

      {/* texts */}

      <div className="w-4/6 my-4 mb-16 mx-auto space-y-5 font-poppins font-semibold leading-10">
        <h6 className="text-primary-color text-transform: uppercase">
          {advertise?.title}
        </h6>

        <p>
          {advertise?.description}
        </p>
      </div>

      {/* <Footer /> */}
    </main>
  );
};

export default AdsDetail1;
